import { styled } from "@mui/material/styles";
import { Button } from "@mui/material";

const SupportActionButton = styled(Button)({
  "borderRadius": "100px",
  "height": "52px",
  "fontSize": "14px",
  "fontWeight": 500,
  "textTransform": "none",
  "boxShadow": "none",
  "&:hover": { boxShadow: "none" },
});

export default SupportActionButton;
